if (!customElements.get('product-upsell')) {
  class ProductUpsell extends HTMLElement {
    constructor() {
      super()

      this.mobileBreakpoint = '(max-width: 989px)';
    }

    connectedCallback() {
      this.attachEvents()
    }

    attachEvents() {
      this.addEventListener('click', (event) => {
        if (this.classList.contains('product-upsell--show-quick-add') || !window.matchMedia(this.mobileBreakpoint).matches) return;
      });

      document.addEventListener('click', (event) => {
        if (event.target.closest('product-upsell') !== this && window.matchMedia(this.mobileBreakpoint).matches) this.hide();
      });
    }

    show() {
      this.classList.add('product-upsell--show-quick-add');
    }

    hide() {
      this.classList.remove('product-upsell--show-quick-add');
    }
  }

  customElements.define('product-upsell', ProductUpsell)
}
